import { lzSAtomWithLocalStorage } from '@lz-store/services';

const lzSAuthRememberAtom = lzSAtomWithLocalStorage<boolean>('authRememberState', false);

export default lzSAuthRememberAtom;
